// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Int from "@rescript/core/src/Core__Int.mjs";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as RelayRouter__Bindings from "rescript-relay-router/src/RelayRouter__Bindings.mjs";
import * as RelayRouter__Internal__DeclarationsSupport from "rescript-relay-router/src/RelayRouter__Internal__DeclarationsSupport.mjs";

var loadedRouteRenderers = new Map();

function make(prepareDisposeTimeoutOpt) {
  var prepareDisposeTimeout = prepareDisposeTimeoutOpt !== undefined ? prepareDisposeTimeoutOpt : 300000;
  var match = RelayRouter__Internal__DeclarationsSupport.makePrepareAssets(loadedRouteRenderers, prepareDisposeTimeout);
  var prepareRoute = match.prepareRoute;
  var getPrepared = match.getPrepared;
  var routeName = "Home";
  var loadRouteRenderer = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Home_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName, loadedRouteRenderers);
  };
  var makePrepareProps = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$1 = "LoggedIn";
  var loadRouteRenderer$1 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../LoggedIn_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$1, loadedRouteRenderers);
  };
  var makePrepareProps$1 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            redirectUrl: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$2 = "SwitchToken";
  var loadRouteRenderer$2 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../SwitchToken_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$2, loadedRouteRenderers);
  };
  var makePrepareProps$2 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            oneTimeToken: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "oneTimeToken"), (function (value) {
                    return value;
                  })),
            redirectUrl: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$3 = "Redirect";
  var loadRouteRenderer$3 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Redirect_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$3, loadedRouteRenderers);
  };
  var makePrepareProps$3 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            childParams: pathParams
          };
  };
  var routeName$4 = "Redirect__ChatParser";
  var loadRouteRenderer$4 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Redirect__ChatParser_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$4, loadedRouteRenderers);
  };
  var makePrepareProps$4 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            chatId: pathParams["chatId"]
          };
  };
  var routeName$5 = "Redirect__WalletParser";
  var loadRouteRenderer$5 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Redirect__WalletParser_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$5, loadedRouteRenderers);
  };
  var makePrepareProps$5 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$6 = "ActivatedPartner";
  var loadRouteRenderer$6 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$6, loadedRouteRenderers);
  };
  var makePrepareProps$6 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            childParams: pathParams
          };
  };
  var routeName$7 = "ActivatedPartner__Wallet";
  var loadRouteRenderer$7 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Wallet_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$7, loadedRouteRenderers);
  };
  var makePrepareProps$7 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$8 = "ActivatedPartner__WalletInitiation";
  var loadRouteRenderer$8 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__WalletInitiation_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$8, loadedRouteRenderers);
  };
  var makePrepareProps$8 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$9 = "ActivatedPartner__WalletAutoSetting";
  var loadRouteRenderer$9 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__WalletAutoSetting_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$9, loadedRouteRenderers);
  };
  var makePrepareProps$9 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$10 = "ActivatedPartner__WalletAutoSettingSuccess";
  var loadRouteRenderer$10 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__WalletAutoSettingSuccess_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$10, loadedRouteRenderers);
  };
  var makePrepareProps$10 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$11 = "ActivatedPartner__PaymentResult";
  var loadRouteRenderer$11 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__PaymentResult_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$11, loadedRouteRenderers);
  };
  var makePrepareProps$11 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            topUpId: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "topUpId"), (function (value) {
                    return value;
                  })),
            redirectUrl: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$12 = "ActivatedPartner__Task";
  var loadRouteRenderer$12 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Task_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$12, loadedRouteRenderers);
  };
  var makePrepareProps$12 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            taskId: pathParams["taskId"],
            shopId: pathParams["shopId"],
            isFreeTask: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isFreeTask"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  }))
          };
  };
  var routeName$13 = "ActivatedPartner__TaskCashback";
  var loadRouteRenderer$13 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__TaskCashback_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$13, loadedRouteRenderers);
  };
  var makePrepareProps$13 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            taskId: pathParams["taskId"],
            shopId: pathParams["shopId"]
          };
  };
  var routeName$14 = "ActivatedPartner__AssignedTasks";
  var loadRouteRenderer$14 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__AssignedTasks_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$14, loadedRouteRenderers);
  };
  var makePrepareProps$14 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            carCheckInDateType: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), (function (value) {
                    return value;
                  })),
            isEstimateSendable: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isEstimateSendable"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            minRepairSections: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            isDraft: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isDraft"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            page: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "page"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  })),
            childParams: pathParams
          };
  };
  var routeName$15 = "ActivatedPartner__AssignedTasks__EmptyTask";
  var loadRouteRenderer$15 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__AssignedTasks__EmptyTask_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$15, loadedRouteRenderers);
  };
  var makePrepareProps$15 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            carCheckInDateType: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), (function (value) {
                    return value;
                  })),
            isEstimateSendable: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isEstimateSendable"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            minRepairSections: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            isDraft: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isDraft"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            page: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "page"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$16 = "ActivatedPartner__AssignedTasks__Task";
  var loadRouteRenderer$16 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__AssignedTasks__Task_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$16, loadedRouteRenderers);
  };
  var makePrepareProps$16 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            taskId: pathParams["taskId"],
            shopId: pathParams["shopId"],
            carCheckInDateType: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), (function (value) {
                    return value;
                  })),
            isEstimateSendable: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isEstimateSendable"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            minRepairSections: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            isDraft: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isDraft"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            page: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "page"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$17 = "ActivatedPartner__PublishedTasks";
  var loadRouteRenderer$17 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__PublishedTasks_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$17, loadedRouteRenderers);
  };
  var makePrepareProps$17 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            isReservable: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isReservable"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  })),
            childParams: pathParams
          };
  };
  var routeName$18 = "ActivatedPartner__PublishedTasks__EmptyTask";
  var loadRouteRenderer$18 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__PublishedTasks__EmptyTask_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$18, loadedRouteRenderers);
  };
  var makePrepareProps$18 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            isReservable: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isReservable"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$19 = "ActivatedPartner__PublishedTasks__Task";
  var loadRouteRenderer$19 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__PublishedTasks__Task_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$19, loadedRouteRenderers);
  };
  var makePrepareProps$19 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            taskId: pathParams["taskId"],
            shopId: pathParams["shopId"],
            isReservable: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isReservable"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$20 = "ActivatedPartner__ReservationTasks";
  var loadRouteRenderer$20 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ReservationTasks_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$20, loadedRouteRenderers);
  };
  var makePrepareProps$20 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            carCheckInDateType: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), (function (value) {
                    return value;
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  })),
            childParams: pathParams
          };
  };
  var routeName$21 = "ActivatedPartner__ReservationTasks__EmptyTask";
  var loadRouteRenderer$21 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ReservationTasks__EmptyTask_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$21, loadedRouteRenderers);
  };
  var makePrepareProps$21 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            carCheckInDateType: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), (function (value) {
                    return value;
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$22 = "ActivatedPartner__ReservationTasks__Task";
  var loadRouteRenderer$22 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ReservationTasks__Task_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$22, loadedRouteRenderers);
  };
  var makePrepareProps$22 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            taskId: pathParams["taskId"],
            shopId: pathParams["shopId"],
            carCheckInDateType: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), (function (value) {
                    return value;
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$23 = "ActivatedPartner__FreeTasks";
  var loadRouteRenderer$23 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__FreeTasks_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$23, loadedRouteRenderers);
  };
  var makePrepareProps$23 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            minRepairSections: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            minEstimatePublishedCount: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minEstimatePublishedCount"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  })),
            addressCodes: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "addressCodes"), (function (value) {
                    return value;
                  })),
            childParams: pathParams
          };
  };
  var routeName$24 = "ActivatedPartner__FreeTasks__EmptyTask";
  var loadRouteRenderer$24 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__FreeTasks__EmptyTask_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$24, loadedRouteRenderers);
  };
  var makePrepareProps$24 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            minRepairSections: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            minEstimatePublishedCount: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minEstimatePublishedCount"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  })),
            addressCodes: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "addressCodes"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$25 = "ActivatedPartner__FreeTasks__Task";
  var loadRouteRenderer$25 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__FreeTasks__Task_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$25, loadedRouteRenderers);
  };
  var makePrepareProps$25 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            taskId: pathParams["taskId"],
            shopId: pathParams["shopId"],
            minRepairSections: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            minEstimatePublishedCount: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minEstimatePublishedCount"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            searchKeyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), (function (value) {
                    return value;
                  })),
            startAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), (function (value) {
                    return value;
                  })),
            endAt: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), (function (value) {
                    return value;
                  })),
            addressCodes: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "addressCodes"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$26 = "ActivatedPartner__Reviews";
  var loadRouteRenderer$26 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Reviews_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$26, loadedRouteRenderers);
  };
  var makePrepareProps$26 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            limit: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "limit"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  }))
          };
  };
  var routeName$27 = "ActivatedPartner__ReviewsExternalShareForm";
  var loadRouteRenderer$27 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ReviewsExternalShareForm_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$27, loadedRouteRenderers);
  };
  var makePrepareProps$27 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$28 = "ActivatedPartner__Cases";
  var loadRouteRenderer$28 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Cases_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$28, loadedRouteRenderers);
  };
  var makePrepareProps$28 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            limit: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "limit"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            keyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), (function (value) {
                    return value;
                  })),
            childParams: pathParams
          };
  };
  var routeName$29 = "ActivatedPartner__Cases__WrittenRepairCases";
  var loadRouteRenderer$29 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Cases__WrittenRepairCases_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$29, loadedRouteRenderers);
  };
  var makePrepareProps$29 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            limit: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "limit"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            keyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$30 = "ActivatedPartner__Cases__ReadyToWriteRepairCases";
  var loadRouteRenderer$30 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Cases__ReadyToWriteRepairCases_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$30, loadedRouteRenderers);
  };
  var makePrepareProps$30 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            offset: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            limit: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "limit"), (function (value) {
                    return Core__Int.fromString(value, undefined);
                  })),
            keyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$31 = "ActivatedPartner__Channels";
  var loadRouteRenderer$31 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Channels_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$31, loadedRouteRenderers);
  };
  var makePrepareProps$31 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            keyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), (function (value) {
                    return value;
                  })),
            onlyUnread: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "onlyUnread"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            childParams: pathParams
          };
  };
  var routeName$32 = "ActivatedPartner__Channels__Chat";
  var loadRouteRenderer$32 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Channels__Chat_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$32, loadedRouteRenderers);
  };
  var makePrepareProps$32 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            toUserId: pathParams["toUserId"],
            shopId: pathParams["shopId"],
            keyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), (function (value) {
                    return value;
                  })),
            onlyUnread: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "onlyUnread"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  })),
            estimateId: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "estimateId"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$33 = "ActivatedPartner__Channels__EmptyChat";
  var loadRouteRenderer$33 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Channels__EmptyChat_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$33, loadedRouteRenderers);
  };
  var makePrepareProps$33 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            keyword: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), (function (value) {
                    return value;
                  })),
            onlyUnread: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "onlyUnread"), (function (value) {
                    switch (value) {
                      case "false" :
                          return false;
                      case "true" :
                          return true;
                      default:
                        return ;
                    }
                  }))
          };
  };
  var routeName$34 = "ActivatedPartner__CallLogs";
  var loadRouteRenderer$34 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__CallLogs_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$34, loadedRouteRenderers);
  };
  var makePrepareProps$34 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            childParams: pathParams
          };
  };
  var routeName$35 = "ActivatedPartner__CallLogs__CallLog";
  var loadRouteRenderer$35 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__CallLogs__CallLog_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$35, loadedRouteRenderers);
  };
  var makePrepareProps$35 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            callId: pathParams["callId"],
            shopId: pathParams["shopId"]
          };
  };
  var routeName$36 = "ActivatedPartner__CallLogs__EmptyCallLog";
  var loadRouteRenderer$36 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__CallLogs__EmptyCallLog_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$36, loadedRouteRenderers);
  };
  var makePrepareProps$36 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$37 = "ActivatedPartner__WriteOutsideCase";
  var loadRouteRenderer$37 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__WriteOutsideCase_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$37, loadedRouteRenderers);
  };
  var makePrepareProps$37 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$38 = "ActivatedPartner__WriteCase";
  var loadRouteRenderer$38 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__WriteCase_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$38, loadedRouteRenderers);
  };
  var makePrepareProps$38 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            taskId: pathParams["taskId"],
            shopId: pathParams["shopId"]
          };
  };
  var routeName$39 = "ActivatedPartner__UpdateRepairCase";
  var loadRouteRenderer$39 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__UpdateRepairCase_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$39, loadedRouteRenderers);
  };
  var makePrepareProps$39 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            caseId: pathParams["caseId"],
            shopId: pathParams["shopId"]
          };
  };
  var routeName$40 = "ActivatedPartner__InquiryAssignPreference";
  var loadRouteRenderer$40 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__InquiryAssignPreference_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$40, loadedRouteRenderers);
  };
  var makePrepareProps$40 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$41 = "ActivatedPartner__InquiryAssignPreferenceRegions";
  var loadRouteRenderer$41 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__InquiryAssignPreferenceRegions_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$41, loadedRouteRenderers);
  };
  var makePrepareProps$41 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            redirectUrl: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$42 = "ActivatedPartner__ShopInformation";
  var loadRouteRenderer$42 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ShopInformation_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$42, loadedRouteRenderers);
  };
  var makePrepareProps$42 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$43 = "ActivatedPartner__ShopIntroduce";
  var loadRouteRenderer$43 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ShopIntroduce_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$43, loadedRouteRenderers);
  };
  var makePrepareProps$43 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"],
            childParams: pathParams
          };
  };
  var routeName$44 = "ActivatedPartner__ShopIntroduce__Basic";
  var loadRouteRenderer$44 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ShopIntroduce__Basic_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$44, loadedRouteRenderers);
  };
  var makePrepareProps$44 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$45 = "ActivatedPartner__ShopIntroduce__Business";
  var loadRouteRenderer$45 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ShopIntroduce__Business_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$45, loadedRouteRenderers);
  };
  var makePrepareProps$45 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$46 = "ActivatedPartner__ShopIntroduce__Facility";
  var loadRouteRenderer$46 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ShopIntroduce__Facility_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$46, loadedRouteRenderers);
  };
  var makePrepareProps$46 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$47 = "ActivatedPartner__ShopIntroduce__Contact";
  var loadRouteRenderer$47 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__ShopIntroduce__Contact_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$47, loadedRouteRenderers);
  };
  var makePrepareProps$47 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$48 = "ActivatedPartner__Account";
  var loadRouteRenderer$48 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Account_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$48, loadedRouteRenderers);
  };
  var makePrepareProps$48 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$49 = "ActivatedPartner__Contact";
  var loadRouteRenderer$49 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../ActivatedPartner__Contact_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$49, loadedRouteRenderers);
  };
  var makePrepareProps$49 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            shopId: pathParams["shopId"]
          };
  };
  var routeName$50 = "Onboarding";
  var loadRouteRenderer$50 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Onboarding_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$50, loadedRouteRenderers);
  };
  var makePrepareProps$50 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$51 = "Onboarding__OnboardingStepOne";
  var loadRouteRenderer$51 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Onboarding__OnboardingStepOne_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$51, loadedRouteRenderers);
  };
  var makePrepareProps$51 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$52 = "Onboarding__OnboardingStepTwo";
  var loadRouteRenderer$52 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Onboarding__OnboardingStepTwo_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$52, loadedRouteRenderers);
  };
  var makePrepareProps$52 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$53 = "Onboarding__OnboardingStepThree";
  var loadRouteRenderer$53 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Onboarding__OnboardingStepThree_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$53, loadedRouteRenderers);
  };
  var makePrepareProps$53 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$54 = "Onboarding__OnboardingWelcome";
  var loadRouteRenderer$54 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Onboarding__OnboardingWelcome_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$54, loadedRouteRenderers);
  };
  var makePrepareProps$54 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$55 = "Subscription";
  var loadRouteRenderer$55 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Subscription_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$55, loadedRouteRenderers);
  };
  var makePrepareProps$55 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$56 = "Subscription__SubscriptionPaymentMethod";
  var loadRouteRenderer$56 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Subscription__SubscriptionPaymentMethod_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$56, loadedRouteRenderers);
  };
  var makePrepareProps$56 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$57 = "Subscription__SubscriptionInitiation";
  var loadRouteRenderer$57 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Subscription__SubscriptionInitiation_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$57, loadedRouteRenderers);
  };
  var makePrepareProps$57 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$58 = "Subscription__SubscriptionPaymentResult";
  var loadRouteRenderer$58 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Subscription__SubscriptionPaymentResult_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$58, loadedRouteRenderers);
  };
  var makePrepareProps$58 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            topUpId: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "topUpId"), (function (value) {
                    return value;
                  })),
            paymentId: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "paymentId"), (function (value) {
                    return value;
                  })),
            cardId: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "cardId"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$59 = "Subscription__SubscriptionAutoSetting";
  var loadRouteRenderer$59 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Subscription__SubscriptionAutoSetting_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$59, loadedRouteRenderers);
  };
  var makePrepareProps$59 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$60 = "Subscription__SubscriptionAutoSettingSuccess";
  var loadRouteRenderer$60 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Subscription__SubscriptionAutoSettingSuccess_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$60, loadedRouteRenderers);
  };
  var makePrepareProps$60 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$61 = "Partnership";
  var loadRouteRenderer$61 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Partnership_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$61, loadedRouteRenderers);
  };
  var makePrepareProps$61 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$62 = "Partnership__ApplyTerms";
  var loadRouteRenderer$62 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Partnership__ApplyTerms_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$62, loadedRouteRenderers);
  };
  var makePrepareProps$62 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$63 = "Partnership__PreferredBusinesses";
  var loadRouteRenderer$63 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Partnership__PreferredBusinesses_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$63, loadedRouteRenderers);
  };
  var makePrepareProps$63 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$64 = "Partnership__ExteriorApplication";
  var loadRouteRenderer$64 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Partnership__ExteriorApplication_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$64, loadedRouteRenderers);
  };
  var makePrepareProps$64 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$65 = "Partnership__ExteriorApplication__ExteriorApplicationStepOne";
  var loadRouteRenderer$65 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Partnership__ExteriorApplication__ExteriorApplicationStepOne_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$65, loadedRouteRenderers);
  };
  var makePrepareProps$65 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$66 = "Partnership__ExteriorApplication__ExteriorApplicationStepTwo";
  var loadRouteRenderer$66 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Partnership__ExteriorApplication__ExteriorApplicationStepTwo_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$66, loadedRouteRenderers);
  };
  var makePrepareProps$66 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$67 = "Partnership__MaintenanceApplication";
  var loadRouteRenderer$67 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Partnership__MaintenanceApplication_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$67, loadedRouteRenderers);
  };
  var makePrepareProps$67 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$68 = "Partnership__ApplyDone";
  var loadRouteRenderer$68 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Partnership__ApplyDone_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$68, loadedRouteRenderers);
  };
  var makePrepareProps$68 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$69 = "Login";
  var loadRouteRenderer$69 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../Login_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$69, loadedRouteRenderers);
  };
  var makePrepareProps$69 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            redirectUrl: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$70 = "PasswordResetWithOTT";
  var loadRouteRenderer$70 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../PasswordResetWithOTT_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$70, loadedRouteRenderers);
  };
  var makePrepareProps$70 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location,
            token: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "token"), (function (value) {
                    return value;
                  }))
          };
  };
  var routeName$71 = "PasswordResetCompleted";
  var loadRouteRenderer$71 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../PasswordResetCompleted_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$71, loadedRouteRenderers);
  };
  var makePrepareProps$71 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$72 = "PasswordReset";
  var loadRouteRenderer$72 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../PasswordReset_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$72, loadedRouteRenderers);
  };
  var makePrepareProps$72 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$73 = "PasswordReset__RequestSmsToMasterUserPhoneNumber";
  var loadRouteRenderer$73 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../PasswordReset__RequestSmsToMasterUserPhoneNumber_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$73, loadedRouteRenderers);
  };
  var makePrepareProps$73 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$74 = "PasswordReset__SmsVerification";
  var loadRouteRenderer$74 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../PasswordReset__SmsVerification_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$74, loadedRouteRenderers);
  };
  var makePrepareProps$74 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$75 = "UpdateNewPassword";
  var loadRouteRenderer$75 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../UpdateNewPassword_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$75, loadedRouteRenderers);
  };
  var makePrepareProps$75 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$76 = "NotFoundUrl";
  var loadRouteRenderer$76 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../NotFoundUrl_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$76, loadedRouteRenderers);
  };
  var makePrepareProps$76 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  var routeName$77 = "FourOhFour";
  var loadRouteRenderer$77 = function () {
    return RelayRouter__Internal__DeclarationsSupport.doLoadRouteRenderer((function () {
                  return import("../FourOhFour_route_renderer.mjs").then(function (m) {
                              return m.renderer;
                            });
                }), routeName$77, loadedRouteRenderers);
  };
  var makePrepareProps$77 = function (environment, pathParams, queryParams, $$location) {
    return {
            environment: environment,
            location: $$location
          };
  };
  return [
          {
            path: "/",
            name: routeName,
            __$rescriptChunkName__: "Home_route_renderer",
            loadRouteRenderer: loadRouteRenderer,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName, loadRouteRenderer, makePrepareProps, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps, (function (pathParams, queryParams) {
                              return "Home:";
                            }), getPrepared, routeName, loadRouteRenderer, intent);
              }),
            children: []
          },
          {
            path: "/logged-in",
            name: routeName$1,
            __$rescriptChunkName__: "LoggedIn_route_renderer",
            loadRouteRenderer: loadRouteRenderer$1,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$1, loadRouteRenderer$1, makePrepareProps$1, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$1, (function (pathParams, queryParams) {
                              return "LoggedIn:" + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), "");
                            }), getPrepared, routeName$1, loadRouteRenderer$1, intent);
              }),
            children: []
          },
          {
            path: "/switch-token",
            name: routeName$2,
            __$rescriptChunkName__: "SwitchToken_route_renderer",
            loadRouteRenderer: loadRouteRenderer$2,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$2, loadRouteRenderer$2, makePrepareProps$2, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$2, (function (pathParams, queryParams) {
                              return "SwitchToken:" + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "oneTimeToken"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), "");
                            }), getPrepared, routeName$2, loadRouteRenderer$2, intent);
              }),
            children: []
          },
          {
            path: "/redirect",
            name: routeName$3,
            __$rescriptChunkName__: "Redirect_route_renderer",
            loadRouteRenderer: loadRouteRenderer$3,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$3, loadRouteRenderer$3, makePrepareProps$3, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$3, (function (pathParams, queryParams) {
                              return "Redirect:";
                            }), getPrepared, routeName$3, loadRouteRenderer$3, intent);
              }),
            children: [
              {
                path: "channels/:chatId",
                name: routeName$4,
                __$rescriptChunkName__: "Redirect__ChatParser_route_renderer",
                loadRouteRenderer: loadRouteRenderer$4,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$4, loadRouteRenderer$4, makePrepareProps$4, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$4, (function (pathParams, queryParams) {
                                  return "Redirect__ChatParser:" + Core__Option.getOr(pathParams["chatId"], "");
                                }), getPrepared, routeName$4, loadRouteRenderer$4, intent);
                  }),
                children: []
              },
              {
                path: "wallet/initiation",
                name: routeName$5,
                __$rescriptChunkName__: "Redirect__WalletParser_route_renderer",
                loadRouteRenderer: loadRouteRenderer$5,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$5, loadRouteRenderer$5, makePrepareProps$5, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$5, (function (pathParams, queryParams) {
                                  return "Redirect__WalletParser:";
                                }), getPrepared, routeName$5, loadRouteRenderer$5, intent);
                  }),
                children: []
              }
            ]
          },
          {
            path: ":shopId",
            name: routeName$6,
            __$rescriptChunkName__: "ActivatedPartner_route_renderer",
            loadRouteRenderer: loadRouteRenderer$6,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$6, loadRouteRenderer$6, makePrepareProps$6, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$6, (function (pathParams, queryParams) {
                              return "ActivatedPartner:" + Core__Option.getOr(pathParams["shopId"], "");
                            }), getPrepared, routeName$6, loadRouteRenderer$6, intent);
              }),
            children: [
              {
                path: "wallet",
                name: routeName$7,
                __$rescriptChunkName__: "ActivatedPartner__Wallet_route_renderer",
                loadRouteRenderer: loadRouteRenderer$7,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$7, loadRouteRenderer$7, makePrepareProps$7, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$7, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__Wallet:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$7, loadRouteRenderer$7, intent);
                  }),
                children: []
              },
              {
                path: "wallet/initiation",
                name: routeName$8,
                __$rescriptChunkName__: "ActivatedPartner__WalletInitiation_route_renderer",
                loadRouteRenderer: loadRouteRenderer$8,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$8, loadRouteRenderer$8, makePrepareProps$8, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$8, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__WalletInitiation:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$8, loadRouteRenderer$8, intent);
                  }),
                children: []
              },
              {
                path: "wallet/auto-setting",
                name: routeName$9,
                __$rescriptChunkName__: "ActivatedPartner__WalletAutoSetting_route_renderer",
                loadRouteRenderer: loadRouteRenderer$9,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$9, loadRouteRenderer$9, makePrepareProps$9, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$9, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__WalletAutoSetting:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$9, loadRouteRenderer$9, intent);
                  }),
                children: []
              },
              {
                path: "wallet/auto-setting/success",
                name: routeName$10,
                __$rescriptChunkName__: "ActivatedPartner__WalletAutoSettingSuccess_route_renderer",
                loadRouteRenderer: loadRouteRenderer$10,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$10, loadRouteRenderer$10, makePrepareProps$10, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$10, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__WalletAutoSettingSuccess:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$10, loadRouteRenderer$10, intent);
                  }),
                children: []
              },
              {
                path: "payment-result",
                name: routeName$11,
                __$rescriptChunkName__: "ActivatedPartner__PaymentResult_route_renderer",
                loadRouteRenderer: loadRouteRenderer$11,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$11, loadRouteRenderer$11, makePrepareProps$11, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$11, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__PaymentResult:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "topUpId"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), "");
                                }), getPrepared, routeName$11, loadRouteRenderer$11, intent);
                  }),
                children: []
              },
              {
                path: "tasks/:taskId",
                name: routeName$12,
                __$rescriptChunkName__: "ActivatedPartner__Task_route_renderer",
                loadRouteRenderer: loadRouteRenderer$12,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$12, loadRouteRenderer$12, makePrepareProps$12, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$12, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__Task:" + Core__Option.getOr(pathParams["taskId"], "") + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isFreeTask"), "");
                                }), getPrepared, routeName$12, loadRouteRenderer$12, intent);
                  }),
                children: []
              },
              {
                path: "task/:taskId/cashback",
                name: routeName$13,
                __$rescriptChunkName__: "ActivatedPartner__TaskCashback_route_renderer",
                loadRouteRenderer: loadRouteRenderer$13,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$13, loadRouteRenderer$13, makePrepareProps$13, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$13, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__TaskCashback:" + Core__Option.getOr(pathParams["taskId"], "") + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$13, loadRouteRenderer$13, intent);
                  }),
                children: []
              },
              {
                path: "tasks/assigned",
                name: routeName$14,
                __$rescriptChunkName__: "ActivatedPartner__AssignedTasks_route_renderer",
                loadRouteRenderer: loadRouteRenderer$14,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$14, loadRouteRenderer$14, makePrepareProps$14, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$14, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__AssignedTasks:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isEstimateSendable"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isDraft"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "page"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "");
                                }), getPrepared, routeName$14, loadRouteRenderer$14, intent);
                  }),
                children: [
                  {
                    path: "",
                    name: routeName$15,
                    __$rescriptChunkName__: "ActivatedPartner__AssignedTasks__EmptyTask_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$15,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$15, loadRouteRenderer$15, makePrepareProps$15, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$15, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__AssignedTasks__EmptyTask:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isEstimateSendable"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isDraft"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "page"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "");
                                    }), getPrepared, routeName$15, loadRouteRenderer$15, intent);
                      }),
                    children: []
                  },
                  {
                    path: ":taskId",
                    name: routeName$16,
                    __$rescriptChunkName__: "ActivatedPartner__AssignedTasks__Task_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$16,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$16, loadRouteRenderer$16, makePrepareProps$16, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$16, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__AssignedTasks__Task:" + Core__Option.getOr(pathParams["taskId"], "") + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isEstimateSendable"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isDraft"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "page"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "");
                                    }), getPrepared, routeName$16, loadRouteRenderer$16, intent);
                      }),
                    children: []
                  }
                ]
              },
              {
                path: "tasks/published",
                name: routeName$17,
                __$rescriptChunkName__: "ActivatedPartner__PublishedTasks_route_renderer",
                loadRouteRenderer: loadRouteRenderer$17,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$17, loadRouteRenderer$17, makePrepareProps$17, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$17, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__PublishedTasks:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isReservable"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "");
                                }), getPrepared, routeName$17, loadRouteRenderer$17, intent);
                  }),
                children: [
                  {
                    path: "",
                    name: routeName$18,
                    __$rescriptChunkName__: "ActivatedPartner__PublishedTasks__EmptyTask_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$18,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$18, loadRouteRenderer$18, makePrepareProps$18, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$18, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__PublishedTasks__EmptyTask:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isReservable"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "");
                                    }), getPrepared, routeName$18, loadRouteRenderer$18, intent);
                      }),
                    children: []
                  },
                  {
                    path: ":taskId",
                    name: routeName$19,
                    __$rescriptChunkName__: "ActivatedPartner__PublishedTasks__Task_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$19,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$19, loadRouteRenderer$19, makePrepareProps$19, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$19, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__PublishedTasks__Task:" + Core__Option.getOr(pathParams["taskId"], "") + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "isReservable"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "");
                                    }), getPrepared, routeName$19, loadRouteRenderer$19, intent);
                      }),
                    children: []
                  }
                ]
              },
              {
                path: "tasks/reservation",
                name: routeName$20,
                __$rescriptChunkName__: "ActivatedPartner__ReservationTasks_route_renderer",
                loadRouteRenderer: loadRouteRenderer$20,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$20, loadRouteRenderer$20, makePrepareProps$20, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$20, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__ReservationTasks:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "");
                                }), getPrepared, routeName$20, loadRouteRenderer$20, intent);
                  }),
                children: [
                  {
                    path: "",
                    name: routeName$21,
                    __$rescriptChunkName__: "ActivatedPartner__ReservationTasks__EmptyTask_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$21,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$21, loadRouteRenderer$21, makePrepareProps$21, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$21, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__ReservationTasks__EmptyTask:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "");
                                    }), getPrepared, routeName$21, loadRouteRenderer$21, intent);
                      }),
                    children: []
                  },
                  {
                    path: ":taskId",
                    name: routeName$22,
                    __$rescriptChunkName__: "ActivatedPartner__ReservationTasks__Task_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$22,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$22, loadRouteRenderer$22, makePrepareProps$22, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$22, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__ReservationTasks__Task:" + Core__Option.getOr(pathParams["taskId"], "") + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "carCheckInDateType"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "");
                                    }), getPrepared, routeName$22, loadRouteRenderer$22, intent);
                      }),
                    children: []
                  }
                ]
              },
              {
                path: "tasks/free",
                name: routeName$23,
                __$rescriptChunkName__: "ActivatedPartner__FreeTasks_route_renderer",
                loadRouteRenderer: loadRouteRenderer$23,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$23, loadRouteRenderer$23, makePrepareProps$23, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$23, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__FreeTasks:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minEstimatePublishedCount"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "addressCodes"), "");
                                }), getPrepared, routeName$23, loadRouteRenderer$23, intent);
                  }),
                children: [
                  {
                    path: "",
                    name: routeName$24,
                    __$rescriptChunkName__: "ActivatedPartner__FreeTasks__EmptyTask_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$24,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$24, loadRouteRenderer$24, makePrepareProps$24, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$24, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__FreeTasks__EmptyTask:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minEstimatePublishedCount"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "addressCodes"), "");
                                    }), getPrepared, routeName$24, loadRouteRenderer$24, intent);
                      }),
                    children: []
                  },
                  {
                    path: ":taskId",
                    name: routeName$25,
                    __$rescriptChunkName__: "ActivatedPartner__FreeTasks__Task_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$25,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$25, loadRouteRenderer$25, makePrepareProps$25, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$25, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__FreeTasks__Task:" + Core__Option.getOr(pathParams["taskId"], "") + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minRepairSections"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "minEstimatePublishedCount"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "searchKeyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "startAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "endAt"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "addressCodes"), "");
                                    }), getPrepared, routeName$25, loadRouteRenderer$25, intent);
                      }),
                    children: []
                  }
                ]
              },
              {
                path: "reviews",
                name: routeName$26,
                __$rescriptChunkName__: "ActivatedPartner__Reviews_route_renderer",
                loadRouteRenderer: loadRouteRenderer$26,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$26, loadRouteRenderer$26, makePrepareProps$26, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$26, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__Reviews:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "limit"), "");
                                }), getPrepared, routeName$26, loadRouteRenderer$26, intent);
                  }),
                children: []
              },
              {
                path: "reviews/external/share-form",
                name: routeName$27,
                __$rescriptChunkName__: "ActivatedPartner__ReviewsExternalShareForm_route_renderer",
                loadRouteRenderer: loadRouteRenderer$27,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$27, loadRouteRenderer$27, makePrepareProps$27, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$27, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__ReviewsExternalShareForm:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$27, loadRouteRenderer$27, intent);
                  }),
                children: []
              },
              {
                path: "cases",
                name: routeName$28,
                __$rescriptChunkName__: "ActivatedPartner__Cases_route_renderer",
                loadRouteRenderer: loadRouteRenderer$28,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$28, loadRouteRenderer$28, makePrepareProps$28, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$28, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__Cases:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "limit"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), "");
                                }), getPrepared, routeName$28, loadRouteRenderer$28, intent);
                  }),
                children: [
                  {
                    path: "written",
                    name: routeName$29,
                    __$rescriptChunkName__: "ActivatedPartner__Cases__WrittenRepairCases_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$29,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$29, loadRouteRenderer$29, makePrepareProps$29, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$29, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__Cases__WrittenRepairCases:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "limit"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), "");
                                    }), getPrepared, routeName$29, loadRouteRenderer$29, intent);
                      }),
                    children: []
                  },
                  {
                    path: "ready-to-write",
                    name: routeName$30,
                    __$rescriptChunkName__: "ActivatedPartner__Cases__ReadyToWriteRepairCases_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$30,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$30, loadRouteRenderer$30, makePrepareProps$30, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$30, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__Cases__ReadyToWriteRepairCases:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "offset"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "limit"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), "");
                                    }), getPrepared, routeName$30, loadRouteRenderer$30, intent);
                      }),
                    children: []
                  }
                ]
              },
              {
                path: "consulting/channels",
                name: routeName$31,
                __$rescriptChunkName__: "ActivatedPartner__Channels_route_renderer",
                loadRouteRenderer: loadRouteRenderer$31,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$31, loadRouteRenderer$31, makePrepareProps$31, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$31, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__Channels:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "onlyUnread"), "");
                                }), getPrepared, routeName$31, loadRouteRenderer$31, intent);
                  }),
                children: [
                  {
                    path: ":toUserId",
                    name: routeName$32,
                    __$rescriptChunkName__: "ActivatedPartner__Channels__Chat_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$32,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$32, loadRouteRenderer$32, makePrepareProps$32, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$32, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__Channels__Chat:" + Core__Option.getOr(pathParams["toUserId"], "") + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "onlyUnread"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "estimateId"), "");
                                    }), getPrepared, routeName$32, loadRouteRenderer$32, intent);
                      }),
                    children: []
                  },
                  {
                    path: "",
                    name: routeName$33,
                    __$rescriptChunkName__: "ActivatedPartner__Channels__EmptyChat_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$33,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$33, loadRouteRenderer$33, makePrepareProps$33, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$33, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__Channels__EmptyChat:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "keyword"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "onlyUnread"), "");
                                    }), getPrepared, routeName$33, loadRouteRenderer$33, intent);
                      }),
                    children: []
                  }
                ]
              },
              {
                path: "counsulting/call-logs",
                name: routeName$34,
                __$rescriptChunkName__: "ActivatedPartner__CallLogs_route_renderer",
                loadRouteRenderer: loadRouteRenderer$34,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$34, loadRouteRenderer$34, makePrepareProps$34, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$34, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__CallLogs:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$34, loadRouteRenderer$34, intent);
                  }),
                children: [
                  {
                    path: ":callId",
                    name: routeName$35,
                    __$rescriptChunkName__: "ActivatedPartner__CallLogs__CallLog_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$35,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$35, loadRouteRenderer$35, makePrepareProps$35, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$35, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__CallLogs__CallLog:" + Core__Option.getOr(pathParams["callId"], "") + Core__Option.getOr(pathParams["shopId"], "");
                                    }), getPrepared, routeName$35, loadRouteRenderer$35, intent);
                      }),
                    children: []
                  },
                  {
                    path: "",
                    name: routeName$36,
                    __$rescriptChunkName__: "ActivatedPartner__CallLogs__EmptyCallLog_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$36,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$36, loadRouteRenderer$36, makePrepareProps$36, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$36, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__CallLogs__EmptyCallLog:" + Core__Option.getOr(pathParams["shopId"], "");
                                    }), getPrepared, routeName$36, loadRouteRenderer$36, intent);
                      }),
                    children: []
                  }
                ]
              },
              {
                path: "cases/write-outside-case",
                name: routeName$37,
                __$rescriptChunkName__: "ActivatedPartner__WriteOutsideCase_route_renderer",
                loadRouteRenderer: loadRouteRenderer$37,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$37, loadRouteRenderer$37, makePrepareProps$37, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$37, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__WriteOutsideCase:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$37, loadRouteRenderer$37, intent);
                  }),
                children: []
              },
              {
                path: "cases/:taskId/write",
                name: routeName$38,
                __$rescriptChunkName__: "ActivatedPartner__WriteCase_route_renderer",
                loadRouteRenderer: loadRouteRenderer$38,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$38, loadRouteRenderer$38, makePrepareProps$38, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$38, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__WriteCase:" + Core__Option.getOr(pathParams["taskId"], "") + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$38, loadRouteRenderer$38, intent);
                  }),
                children: []
              },
              {
                path: "cases/:caseId/update",
                name: routeName$39,
                __$rescriptChunkName__: "ActivatedPartner__UpdateRepairCase_route_renderer",
                loadRouteRenderer: loadRouteRenderer$39,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$39, loadRouteRenderer$39, makePrepareProps$39, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$39, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__UpdateRepairCase:" + Core__Option.getOr(pathParams["caseId"], "") + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$39, loadRouteRenderer$39, intent);
                  }),
                children: []
              },
              {
                path: "inquiry-assign-preference",
                name: routeName$40,
                __$rescriptChunkName__: "ActivatedPartner__InquiryAssignPreference_route_renderer",
                loadRouteRenderer: loadRouteRenderer$40,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$40, loadRouteRenderer$40, makePrepareProps$40, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$40, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__InquiryAssignPreference:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$40, loadRouteRenderer$40, intent);
                  }),
                children: []
              },
              {
                path: "inquiry-assign-preference/regions",
                name: routeName$41,
                __$rescriptChunkName__: "ActivatedPartner__InquiryAssignPreferenceRegions_route_renderer",
                loadRouteRenderer: loadRouteRenderer$41,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$41, loadRouteRenderer$41, makePrepareProps$41, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$41, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__InquiryAssignPreferenceRegions:" + Core__Option.getOr(pathParams["shopId"], "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), "");
                                }), getPrepared, routeName$41, loadRouteRenderer$41, intent);
                  }),
                children: []
              },
              {
                path: "shop-information",
                name: routeName$42,
                __$rescriptChunkName__: "ActivatedPartner__ShopInformation_route_renderer",
                loadRouteRenderer: loadRouteRenderer$42,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$42, loadRouteRenderer$42, makePrepareProps$42, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$42, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__ShopInformation:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$42, loadRouteRenderer$42, intent);
                  }),
                children: []
              },
              {
                path: "shop-introduce",
                name: routeName$43,
                __$rescriptChunkName__: "ActivatedPartner__ShopIntroduce_route_renderer",
                loadRouteRenderer: loadRouteRenderer$43,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$43, loadRouteRenderer$43, makePrepareProps$43, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$43, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__ShopIntroduce:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$43, loadRouteRenderer$43, intent);
                  }),
                children: [
                  {
                    path: "basic",
                    name: routeName$44,
                    __$rescriptChunkName__: "ActivatedPartner__ShopIntroduce__Basic_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$44,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$44, loadRouteRenderer$44, makePrepareProps$44, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$44, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__ShopIntroduce__Basic:" + Core__Option.getOr(pathParams["shopId"], "");
                                    }), getPrepared, routeName$44, loadRouteRenderer$44, intent);
                      }),
                    children: []
                  },
                  {
                    path: "business",
                    name: routeName$45,
                    __$rescriptChunkName__: "ActivatedPartner__ShopIntroduce__Business_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$45,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$45, loadRouteRenderer$45, makePrepareProps$45, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$45, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__ShopIntroduce__Business:" + Core__Option.getOr(pathParams["shopId"], "");
                                    }), getPrepared, routeName$45, loadRouteRenderer$45, intent);
                      }),
                    children: []
                  },
                  {
                    path: "facility",
                    name: routeName$46,
                    __$rescriptChunkName__: "ActivatedPartner__ShopIntroduce__Facility_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$46,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$46, loadRouteRenderer$46, makePrepareProps$46, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$46, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__ShopIntroduce__Facility:" + Core__Option.getOr(pathParams["shopId"], "");
                                    }), getPrepared, routeName$46, loadRouteRenderer$46, intent);
                      }),
                    children: []
                  },
                  {
                    path: "contact",
                    name: routeName$47,
                    __$rescriptChunkName__: "ActivatedPartner__ShopIntroduce__Contact_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$47,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$47, loadRouteRenderer$47, makePrepareProps$47, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$47, (function (pathParams, queryParams) {
                                      return "ActivatedPartner__ShopIntroduce__Contact:" + Core__Option.getOr(pathParams["shopId"], "");
                                    }), getPrepared, routeName$47, loadRouteRenderer$47, intent);
                      }),
                    children: []
                  }
                ]
              },
              {
                path: "account",
                name: routeName$48,
                __$rescriptChunkName__: "ActivatedPartner__Account_route_renderer",
                loadRouteRenderer: loadRouteRenderer$48,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$48, loadRouteRenderer$48, makePrepareProps$48, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$48, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__Account:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$48, loadRouteRenderer$48, intent);
                  }),
                children: []
              },
              {
                path: "contact",
                name: routeName$49,
                __$rescriptChunkName__: "ActivatedPartner__Contact_route_renderer",
                loadRouteRenderer: loadRouteRenderer$49,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$49, loadRouteRenderer$49, makePrepareProps$49, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$49, (function (pathParams, queryParams) {
                                  return "ActivatedPartner__Contact:" + Core__Option.getOr(pathParams["shopId"], "");
                                }), getPrepared, routeName$49, loadRouteRenderer$49, intent);
                  }),
                children: []
              }
            ]
          },
          {
            path: "/onboarding",
            name: routeName$50,
            __$rescriptChunkName__: "Onboarding_route_renderer",
            loadRouteRenderer: loadRouteRenderer$50,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$50, loadRouteRenderer$50, makePrepareProps$50, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$50, (function (pathParams, queryParams) {
                              return "Onboarding:";
                            }), getPrepared, routeName$50, loadRouteRenderer$50, intent);
              }),
            children: [
              {
                path: "step-one",
                name: routeName$51,
                __$rescriptChunkName__: "Onboarding__OnboardingStepOne_route_renderer",
                loadRouteRenderer: loadRouteRenderer$51,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$51, loadRouteRenderer$51, makePrepareProps$51, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$51, (function (pathParams, queryParams) {
                                  return "Onboarding__OnboardingStepOne:";
                                }), getPrepared, routeName$51, loadRouteRenderer$51, intent);
                  }),
                children: []
              },
              {
                path: "step-two",
                name: routeName$52,
                __$rescriptChunkName__: "Onboarding__OnboardingStepTwo_route_renderer",
                loadRouteRenderer: loadRouteRenderer$52,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$52, loadRouteRenderer$52, makePrepareProps$52, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$52, (function (pathParams, queryParams) {
                                  return "Onboarding__OnboardingStepTwo:";
                                }), getPrepared, routeName$52, loadRouteRenderer$52, intent);
                  }),
                children: []
              },
              {
                path: "step-three",
                name: routeName$53,
                __$rescriptChunkName__: "Onboarding__OnboardingStepThree_route_renderer",
                loadRouteRenderer: loadRouteRenderer$53,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$53, loadRouteRenderer$53, makePrepareProps$53, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$53, (function (pathParams, queryParams) {
                                  return "Onboarding__OnboardingStepThree:";
                                }), getPrepared, routeName$53, loadRouteRenderer$53, intent);
                  }),
                children: []
              },
              {
                path: "welcome",
                name: routeName$54,
                __$rescriptChunkName__: "Onboarding__OnboardingWelcome_route_renderer",
                loadRouteRenderer: loadRouteRenderer$54,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$54, loadRouteRenderer$54, makePrepareProps$54, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$54, (function (pathParams, queryParams) {
                                  return "Onboarding__OnboardingWelcome:";
                                }), getPrepared, routeName$54, loadRouteRenderer$54, intent);
                  }),
                children: []
              }
            ]
          },
          {
            path: "/subscription",
            name: routeName$55,
            __$rescriptChunkName__: "Subscription_route_renderer",
            loadRouteRenderer: loadRouteRenderer$55,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$55, loadRouteRenderer$55, makePrepareProps$55, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$55, (function (pathParams, queryParams) {
                              return "Subscription:";
                            }), getPrepared, routeName$55, loadRouteRenderer$55, intent);
              }),
            children: [
              {
                path: "payment-method",
                name: routeName$56,
                __$rescriptChunkName__: "Subscription__SubscriptionPaymentMethod_route_renderer",
                loadRouteRenderer: loadRouteRenderer$56,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$56, loadRouteRenderer$56, makePrepareProps$56, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$56, (function (pathParams, queryParams) {
                                  return "Subscription__SubscriptionPaymentMethod:";
                                }), getPrepared, routeName$56, loadRouteRenderer$56, intent);
                  }),
                children: []
              },
              {
                path: "initiation",
                name: routeName$57,
                __$rescriptChunkName__: "Subscription__SubscriptionInitiation_route_renderer",
                loadRouteRenderer: loadRouteRenderer$57,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$57, loadRouteRenderer$57, makePrepareProps$57, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$57, (function (pathParams, queryParams) {
                                  return "Subscription__SubscriptionInitiation:";
                                }), getPrepared, routeName$57, loadRouteRenderer$57, intent);
                  }),
                children: []
              },
              {
                path: "payment-result",
                name: routeName$58,
                __$rescriptChunkName__: "Subscription__SubscriptionPaymentResult_route_renderer",
                loadRouteRenderer: loadRouteRenderer$58,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$58, loadRouteRenderer$58, makePrepareProps$58, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$58, (function (pathParams, queryParams) {
                                  return "Subscription__SubscriptionPaymentResult:" + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "topUpId"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "paymentId"), "") + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "cardId"), "");
                                }), getPrepared, routeName$58, loadRouteRenderer$58, intent);
                  }),
                children: []
              },
              {
                path: "auto-setting",
                name: routeName$59,
                __$rescriptChunkName__: "Subscription__SubscriptionAutoSetting_route_renderer",
                loadRouteRenderer: loadRouteRenderer$59,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$59, loadRouteRenderer$59, makePrepareProps$59, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$59, (function (pathParams, queryParams) {
                                  return "Subscription__SubscriptionAutoSetting:";
                                }), getPrepared, routeName$59, loadRouteRenderer$59, intent);
                  }),
                children: []
              },
              {
                path: "auto-setting-success",
                name: routeName$60,
                __$rescriptChunkName__: "Subscription__SubscriptionAutoSettingSuccess_route_renderer",
                loadRouteRenderer: loadRouteRenderer$60,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$60, loadRouteRenderer$60, makePrepareProps$60, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$60, (function (pathParams, queryParams) {
                                  return "Subscription__SubscriptionAutoSettingSuccess:";
                                }), getPrepared, routeName$60, loadRouteRenderer$60, intent);
                  }),
                children: []
              }
            ]
          },
          {
            path: "/partnership",
            name: routeName$61,
            __$rescriptChunkName__: "Partnership_route_renderer",
            loadRouteRenderer: loadRouteRenderer$61,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$61, loadRouteRenderer$61, makePrepareProps$61, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$61, (function (pathParams, queryParams) {
                              return "Partnership:";
                            }), getPrepared, routeName$61, loadRouteRenderer$61, intent);
              }),
            children: [
              {
                path: "terms",
                name: routeName$62,
                __$rescriptChunkName__: "Partnership__ApplyTerms_route_renderer",
                loadRouteRenderer: loadRouteRenderer$62,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$62, loadRouteRenderer$62, makePrepareProps$62, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$62, (function (pathParams, queryParams) {
                                  return "Partnership__ApplyTerms:";
                                }), getPrepared, routeName$62, loadRouteRenderer$62, intent);
                  }),
                children: []
              },
              {
                path: "preferred-businesses",
                name: routeName$63,
                __$rescriptChunkName__: "Partnership__PreferredBusinesses_route_renderer",
                loadRouteRenderer: loadRouteRenderer$63,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$63, loadRouteRenderer$63, makePrepareProps$63, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$63, (function (pathParams, queryParams) {
                                  return "Partnership__PreferredBusinesses:";
                                }), getPrepared, routeName$63, loadRouteRenderer$63, intent);
                  }),
                children: []
              },
              {
                path: "exterior-application",
                name: routeName$64,
                __$rescriptChunkName__: "Partnership__ExteriorApplication_route_renderer",
                loadRouteRenderer: loadRouteRenderer$64,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$64, loadRouteRenderer$64, makePrepareProps$64, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$64, (function (pathParams, queryParams) {
                                  return "Partnership__ExteriorApplication:";
                                }), getPrepared, routeName$64, loadRouteRenderer$64, intent);
                  }),
                children: [
                  {
                    path: "step-one",
                    name: routeName$65,
                    __$rescriptChunkName__: "Partnership__ExteriorApplication__ExteriorApplicationStepOne_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$65,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$65, loadRouteRenderer$65, makePrepareProps$65, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$65, (function (pathParams, queryParams) {
                                      return "Partnership__ExteriorApplication__ExteriorApplicationStepOne:";
                                    }), getPrepared, routeName$65, loadRouteRenderer$65, intent);
                      }),
                    children: []
                  },
                  {
                    path: "step-two",
                    name: routeName$66,
                    __$rescriptChunkName__: "Partnership__ExteriorApplication__ExteriorApplicationStepTwo_route_renderer",
                    loadRouteRenderer: loadRouteRenderer$66,
                    preloadCode: (function (environment, pathParams, queryParams, $$location) {
                        return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$66, loadRouteRenderer$66, makePrepareProps$66, environment, pathParams, queryParams, $$location);
                      }),
                    prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                        return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$66, (function (pathParams, queryParams) {
                                      return "Partnership__ExteriorApplication__ExteriorApplicationStepTwo:";
                                    }), getPrepared, routeName$66, loadRouteRenderer$66, intent);
                      }),
                    children: []
                  }
                ]
              },
              {
                path: "maintenance-application",
                name: routeName$67,
                __$rescriptChunkName__: "Partnership__MaintenanceApplication_route_renderer",
                loadRouteRenderer: loadRouteRenderer$67,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$67, loadRouteRenderer$67, makePrepareProps$67, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$67, (function (pathParams, queryParams) {
                                  return "Partnership__MaintenanceApplication:";
                                }), getPrepared, routeName$67, loadRouteRenderer$67, intent);
                  }),
                children: []
              },
              {
                path: "done",
                name: routeName$68,
                __$rescriptChunkName__: "Partnership__ApplyDone_route_renderer",
                loadRouteRenderer: loadRouteRenderer$68,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$68, loadRouteRenderer$68, makePrepareProps$68, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$68, (function (pathParams, queryParams) {
                                  return "Partnership__ApplyDone:";
                                }), getPrepared, routeName$68, loadRouteRenderer$68, intent);
                  }),
                children: []
              }
            ]
          },
          {
            path: "/login",
            name: routeName$69,
            __$rescriptChunkName__: "Login_route_renderer",
            loadRouteRenderer: loadRouteRenderer$69,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$69, loadRouteRenderer$69, makePrepareProps$69, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$69, (function (pathParams, queryParams) {
                              return "Login:" + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), "");
                            }), getPrepared, routeName$69, loadRouteRenderer$69, intent);
              }),
            children: []
          },
          {
            path: "/password-reset",
            name: routeName$70,
            __$rescriptChunkName__: "PasswordResetWithOTT_route_renderer",
            loadRouteRenderer: loadRouteRenderer$70,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$70, loadRouteRenderer$70, makePrepareProps$70, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$70, (function (pathParams, queryParams) {
                              return "PasswordResetWithOTT:" + Core__Option.getOr(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "token"), "");
                            }), getPrepared, routeName$70, loadRouteRenderer$70, intent);
              }),
            children: []
          },
          {
            path: "/password-reset/completed",
            name: routeName$71,
            __$rescriptChunkName__: "PasswordResetCompleted_route_renderer",
            loadRouteRenderer: loadRouteRenderer$71,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$71, loadRouteRenderer$71, makePrepareProps$71, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$71, (function (pathParams, queryParams) {
                              return "PasswordResetCompleted:";
                            }), getPrepared, routeName$71, loadRouteRenderer$71, intent);
              }),
            children: []
          },
          {
            path: "/password-reset/sms-verification",
            name: routeName$72,
            __$rescriptChunkName__: "PasswordReset_route_renderer",
            loadRouteRenderer: loadRouteRenderer$72,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$72, loadRouteRenderer$72, makePrepareProps$72, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$72, (function (pathParams, queryParams) {
                              return "PasswordReset:";
                            }), getPrepared, routeName$72, loadRouteRenderer$72, intent);
              }),
            children: [
              {
                path: "step-one",
                name: routeName$73,
                __$rescriptChunkName__: "PasswordReset__RequestSmsToMasterUserPhoneNumber_route_renderer",
                loadRouteRenderer: loadRouteRenderer$73,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$73, loadRouteRenderer$73, makePrepareProps$73, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$73, (function (pathParams, queryParams) {
                                  return "PasswordReset__RequestSmsToMasterUserPhoneNumber:";
                                }), getPrepared, routeName$73, loadRouteRenderer$73, intent);
                  }),
                children: []
              },
              {
                path: "step-two",
                name: routeName$74,
                __$rescriptChunkName__: "PasswordReset__SmsVerification_route_renderer",
                loadRouteRenderer: loadRouteRenderer$74,
                preloadCode: (function (environment, pathParams, queryParams, $$location) {
                    return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$74, loadRouteRenderer$74, makePrepareProps$74, environment, pathParams, queryParams, $$location);
                  }),
                prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                    return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$74, (function (pathParams, queryParams) {
                                  return "PasswordReset__SmsVerification:";
                                }), getPrepared, routeName$74, loadRouteRenderer$74, intent);
                  }),
                children: []
              }
            ]
          },
          {
            path: "/password-reset/update",
            name: routeName$75,
            __$rescriptChunkName__: "UpdateNewPassword_route_renderer",
            loadRouteRenderer: loadRouteRenderer$75,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$75, loadRouteRenderer$75, makePrepareProps$75, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$75, (function (pathParams, queryParams) {
                              return "UpdateNewPassword:";
                            }), getPrepared, routeName$75, loadRouteRenderer$75, intent);
              }),
            children: []
          },
          {
            path: "/404",
            name: routeName$76,
            __$rescriptChunkName__: "NotFoundUrl_route_renderer",
            loadRouteRenderer: loadRouteRenderer$76,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$76, loadRouteRenderer$76, makePrepareProps$76, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$76, (function (pathParams, queryParams) {
                              return "NotFoundUrl:";
                            }), getPrepared, routeName$76, loadRouteRenderer$76, intent);
              }),
            children: []
          },
          {
            path: "*",
            name: routeName$77,
            __$rescriptChunkName__: "FourOhFour_route_renderer",
            loadRouteRenderer: loadRouteRenderer$77,
            preloadCode: (function (environment, pathParams, queryParams, $$location) {
                return RelayRouter__Internal__DeclarationsSupport.preloadCode(loadedRouteRenderers, routeName$77, loadRouteRenderer$77, makePrepareProps$77, environment, pathParams, queryParams, $$location);
              }),
            prepare: (function (environment, pathParams, queryParams, $$location, intent) {
                return prepareRoute(environment, pathParams, queryParams, $$location, makePrepareProps$77, (function (pathParams, queryParams) {
                              return "FourOhFour:";
                            }), getPrepared, routeName$77, loadRouteRenderer$77, intent);
              }),
            children: []
          }
        ];
}

export {
  make ,
}
/* loadedRouteRenderers Not a pure module */
